import {Inject, Injectable} from '@angular/core';
import {DateAdapter} from "@angular/material/core";
import {DateRange} from "@angular/material/datepicker";
import {rangeDate} from "./all-devices.service";

@Injectable({
    providedIn: 'root'
})
export class HunaDateStrategyService {

    constructor(
        private _dateAdapter: DateAdapter<Date>) {
    }

    public deltaDate = 7;
    public delta: number = 7;

    // selectionFinished(date: Date | null): DateRange<Date> {
    //     return this._createMondayMondayRange(date);
    // }
    //
    // createPreview(activeDate: Date | null): DateRange<Date> {
    //     return this._createMondayMondayRange(activeDate);
    // }


    start: any;


    selectionFinished(date: Date, currentRange: DateRange<Date>) {
        let {start, end} = currentRange;
        if (start == null || (start && end)) {
            start = date;
            end = null;
        } else if (end == null) {
            const maxDate = this._dateAdapter.addCalendarDays(start, this.delta);
            end = date ? date > maxDate ? maxDate : date : null;
        }
        return new DateRange<Date>(start, end);
    }

    createPreview(activeDate: Date | null, currentRange: DateRange<Date>): DateRange<Date> {
        if (currentRange.start && !currentRange.end) {
            const maxDate = this._dateAdapter.addCalendarDays(currentRange.start, this.delta);
            const rangeEnd = activeDate ? activeDate > maxDate ? maxDate : activeDate : null;
            return new DateRange(currentRange.start, rangeEnd);
        }
        return new DateRange<Date>(null, null);
    }


    private _createMondayMondayRange(date: Date | null): DateRange<Date> {
        if (date) {
            const newDate = this.getDateFromTo(date.getTime(), -this.delta);
            const start = this._dateAdapter.addCalendarDays(newDate.fromDate, this.delta);
            const end = this._dateAdapter.addCalendarDays(newDate.toDate, this.delta);
            return new DateRange<Date>(start, end);
        }
        return new DateRange<Date>(null, null);
    }


    getFirstMonday(lastDay: number, deltaDate: number): { date1: Date, date2: Date } {
        //console.log("lastDay: ", lastDay, ". deltaDate: ", deltaDate)
        const dayRiferiment = 1;//lunedì
        const firstDay = new Date(lastDay);
        const todaySolar = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate());
        const firstRiferimentStartingToday = dayRiferiment - (todaySolar.getDay() || 7);
        // console.log("firstRiferimentStartingToday: ", firstRiferimentStartingToday)
        let date1 = this._dateAdapter.addCalendarDays(todaySolar, firstRiferimentStartingToday);
        let date2 = this._dateAdapter.addCalendarDays(date1, deltaDate);
        // console.log("date1: ", date1, "- date2: ", date2)
        if (date1.getTime() <= Date.now()) {
            return {date1, date2};
        } else {
            return this.getFirstMonday(Date.now(), deltaDate);
        }
    }

    public getDateFromTo(lastDay: number, deltaDate: number): { toDate: Date, fromDate: Date } {
        const date = this.getFirstMonday(lastDay, deltaDate);
        let date1 = date.date1;
        let date2 = date.date2;
        if (deltaDate >= 0) {
            if (date2.getTime() >= Date.now() || date1.getTime() >= Date.now()) {
                const today = new Date(Date.now());
                date2 = new Date(today.getFullYear(), today.getMonth(), today.getDate());
                date1 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate() - this.delta);
            }
            return {fromDate: date1, toDate: date2}
        } else {
            if (date1.getTime() >= Date.now() || date2.getTime() >= Date.now()) {
                const today = new Date(Date.now());
                date2 = new Date(today.getFullYear(), today.getMonth(), today.getDate());
                date1 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate() - this.delta);
            }
            return {fromDate: date2, toDate: date1}
        }
    }

    public getDeltaMonth(date: Date, numberMonth: number): rangeDate {
        const date1 = date;
        date1.setDate(1)
        date1.setHours(0, 0, 0, 0);
        const date2 = new Date(date1.getTime());
        date2.setMonth(date1.getMonth() + numberMonth);
        date2.setDate(1);
        date2.setHours(0, 0, 0, 0);
        if (date1.getTime() > date2.getTime()) {
            return {fromDate: date2, toDate: date1}
        } else {
            return {fromDate: date1, toDate: date2}
        }
    }


    public getDeltaYear(date: Date, numberYear: number): rangeDate {
        const date1 = date;
        date1.setMonth(0);
        date1.setDate(1);
        date1.setHours(0, 0, 0, 0);
        const date2 = new Date(date1.getTime());
        date2.setFullYear(date1.getFullYear() + numberYear);
        date2.setMonth(0);
        date2.setDate(1);
        date2.setHours(0, 0, 0, 0);
        if (date1.getTime() > date2.getTime()) {
            return {fromDate: date2, toDate: date1}
        } else {
            return {fromDate: date1, toDate: date2}
        }
    }
}
